var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4985 9.83301L10.0026 5.49145",
    stroke: "#585D66",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25591 16.3087L8.25496 17.0587C8.45918 17.059 8.65467 16.976 8.79629 16.8288L8.25591 16.3087ZM3.75278 11.9746L3.2124 11.4545C3.07079 11.6017 2.99529 11.8002 3.00336 12.0043L3.75278 11.9746ZM3.92399 16.3032L3.17457 16.3328L3.20303 17.0523L3.92303 17.0532L3.92399 16.3032ZM12.2746 4.56244L15.3368 7.50962L16.3769 6.42887L13.3148 3.48169L12.2746 4.56244ZM15.3435 7.86311L7.71554 15.7886L8.79629 16.8288L16.4243 8.90329L15.3435 7.86311ZM4.29316 12.4947L11.9211 4.5692L10.8404 3.52902L3.2124 11.4545L4.29316 12.4947ZM8.25687 15.5587L3.92495 15.5532L3.92303 17.0532L8.25496 17.0587L8.25687 15.5587ZM4.6734 16.2735L4.50219 11.945L3.00336 12.0043L3.17457 16.3328L4.6734 16.2735ZM15.3368 7.50962C15.4362 7.60537 15.4393 7.76363 15.3435 7.86311L16.4243 8.90329C17.0945 8.20693 17.0733 7.09909 16.3769 6.42887L15.3368 7.50962ZM13.3148 3.48169C12.6184 2.81147 11.5106 2.83266 10.8404 3.52902L11.9211 4.5692C12.0169 4.46972 12.1751 4.4667 12.2746 4.56244L13.3148 3.48169Z",
    fill: "#585D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 16.333H10.8337",
    stroke: "#585D66",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatIcon);
export default __webpack_public_path__ + "static/media/new-chat-icon.2f1344ee8fb1983d1895207901728554.svg";
export { ForwardRef as ReactComponent };